import Box from '@mui/material/Box';
import type { ReactNode } from 'react';

export const MAX_WIDTH = 450;

interface Props {
  children: ReactNode | ReactNode[];
  noPadding?: boolean;
  fullWidth?: boolean;
}

export const FormFieldsWrapper = ({
  children,
  noPadding = false,
  fullWidth = false
}: Props) => {
  return (
    <Box
      flexDirection="column"
      display="flex"
      gap={2.5}
      pt={noPadding ? 0 : 3}
      width={fullWidth ? '100%' : 'auto'}
      maxWidth={fullWidth ? 'none' : MAX_WIDTH}
    >
      {children}
    </Box>
  );
};
